import { render, staticRenderFns } from "./android13.vue?vue&type=template&id=7008c2dd&scoped=true"
import script from "./android13.vue?vue&type=script&lang=js"
export * from "./android13.vue?vue&type=script&lang=js"
import style0 from "./android13.vue?vue&type=style&index=0&id=7008c2dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008c2dd",
  null
  
)

export default component.exports